import { createAction, props } from '@ngrx/store';
import { Lot, MarketType } from 'src/app/components/bids-and-offers/lots.model';
import { Negotiation } from 'src/app/components/negotiations/negotiations.model';

export const newTableData = createAction(
  '[Data Table] Initialze Data',
  props<{
    newLots: Lot[];
    market: MarketType;
  }>()
);
export const removeRow = createAction(
  '[Data Table] Remove Table Row',
  props<{ lotId: string }>()
);

export const changeTableMarket = createAction(
  '[Data Table] Change Market Type',
  props<{ marketType: MarketType }>()
);

export const fetchData = createAction(
  '[Data Table] Fetch Lots data',
  props<{ limit: number; marketType: MarketType }>()
);
